import { string, object, func } from 'prop-types'
import {
  Input,
  PopoverV2,
  WithTooltip,
  renderIcon,
  kuiperClassNames,
} from '@opallabs/kuiper'
import CtaPopoverContent from '../CallToAction/CtaPopoverContent'
import './styles.scss'

const popoverComponents = {
  cta: CtaPopoverContent,
  text: Input,
}

const getButton = (icon, tooltipText) => (
  <WithTooltip
    className="overlay-option-button"
    content={tooltipText}
    tooltipOptions={{ position: 'top' }}
  >
    <div className={kuiperClassNames('overlay-option-icon')}>
      {renderIcon(icon, { ariaMode: 'hidden' })}
    </div>
  </WithTooltip>
)

const OverlayOptionButton = ({
  additionalPopoverProps = {},
  icon,
  onClosed,
  onOpened,
  popoverComponentType = 'text',
  tooltipText,
  value,
}) => {
  const PopoverContent = popoverComponents[popoverComponentType]
  return (
    <PopoverV2
      className="overlay-option-button-popover cta-icon-popover"
      onClosed={onClosed}
      onOpened={onOpened}
      content={<PopoverContent value={value} {...additionalPopoverProps} />}
      trigger={getButton(icon, tooltipText)}
    />
  )
}

OverlayOptionButton.propTypes = {
  additionalPopoverProps: object,
  icon: string,
  onClosed: func,
  onOpened: func,
  popoverComponentType: string,
  tooltipText: string,
  value: string,
}

export default OverlayOptionButton
